import {
	ClientChatResponse,
	MessageResponse, NotifyingNewUserEvent,
	RegistrationEvent, SendingMessageEvent,
	TypingNotificationEvent, TypingParameters
} from './types';

import * as signalR from "@microsoft/signalr";
import { IChatNotification } from './types/ChatNotification';

export const socket = (() => {
	let resolveCallback: null | (() => void) = null;
	let onMessageCallback: null | ((notification: IChatNotification) => void) = null;
	const startedPromise = new Promise((resolve) => resolveCallback = resolve)
	return {
		isAlive: false,
		connection: null as signalR.HubConnection | null,
		notifyTyping(receiverId: number) {
			const params: TypingParameters = {
				receiverId
			};
			this.connection?.invoke("SendTypingNotification", params);
		},
		waitStarted() {
			return startedPromise;
		},
		onChatNotification(callback: (notification: IChatNotification) => void) {
			onMessageCallback = callback;
		},
		start(
			token: string,
			messageCallback: (message: MessageResponse) => void,
			typingCallback: (typing: ClientChatResponse) => void,
			registrationCallback: (registration: ClientChatResponse) => void
		) {
			if (!token) return;

			this.isAlive = true;

			this.connection = new signalR.HubConnectionBuilder()
				.withUrl(`${process.env.REACT_APP_CHAT_HOST}/Broadcasting`, {
					accessTokenFactory: () => token
				})
				.configureLogging(signalR.LogLevel.Debug)
				.build();

			this.connection.on('NotifyTyping', (event: TypingNotificationEvent) => {
				catchTyping(event, typingCallback);
			});

			this.connection.on('AddUser', (event: RegistrationEvent) => {
				catchRegistration(event, registrationCallback);
			});

			this.connection.on('SendMessage', (event: SendingMessageEvent) => {
				catchMessage(event, messageCallback);
			});

			this.connection.on('NotifyNewUser', (event: NotifyingNewUserEvent) => {
				catchNotificationNewUser(event, onMessageCallback);
			})

			if (resolveCallback) resolveCallback();
			this.connection.start()
		}
	}
})();

export type BroadcastingType = typeof socket;

function catchNotificationNewUser(data: NotifyingNewUserEvent, callback: null | ((notification: IChatNotification) => void)) {
	const notification: IChatNotification = { ...data };
	if (callback) callback(notification);
	return true;
}

function catchMessage(data: SendingMessageEvent, callback: (message: MessageResponse) => void) {
	const message: MessageResponse = {
		isIncoming: data.receiverId < 1,
		receiverId: data.receiverId,
		receiverName: '',
		senderId: data.sender.id,
		senderName: data.sender.name,
		text: data.text,
		time: data.time
	}
	callback(message);
	return true;
}

function catchTyping(data: TypingNotificationEvent, callback: (typing: ClientChatResponse) => void) {
	if (!!data.receiverId) return;
	const user: ClientChatResponse = {
		companionPhone: data.sender.phone,
		lastMessages: null,
		companionId: data.sender.id,
		companionName: data.sender.name
	};
	callback(user);
	return true;
}

function catchRegistration(data: RegistrationEvent, callback: (registration: ClientChatResponse) => void) {
	const user: ClientChatResponse = {
		companionPhone: data.sender.phone,
		lastMessages: null,
		companionId: data.sender.id,
		companionName: data.sender.name
	};
	callback(user);
	return true;
}
